/* VENDORED — DO NOT EDIT BY HAND. See scripts/vendor-manifest.mjs.
   source:  andavo-dev libs/client/shared/shared/util/api/src/localPortRouting.ts
   commit:  e4d5051bce
   repoint: this file maps to @andavo/* at merge into andavo-dev.
 */
/**
 * Local development port routing.
 *
 * When the API base URL points at a local address (localhost, 127.0.0.1,
 * 192.168.x.x, 10.x.x.x) each Java service runs on its own port. This helper maps
 * request paths to the correct service port so that the mobile "Local"
 * environment option works without a reverse proxy.
 */

const LOCAL_URL_PATTERN =
  /^http:\/\/(localhost|127\.0\.0\.1|192\.168\.\d+\.\d+|10\.\d+\.\d+\.\d+)(:\d+)?$/;

/** Port mapping — order matters: first match wins. */
const PORT_ROUTES: readonly { prefixes: string[]; port: number }[] = [
  { prefixes: ['v1/dev/live-activity-scenarios'], port: 8007 },
  { prefixes: ['v1/trips', 'v1/flights', 'v1/risk'], port: 8007 },
  { prefixes: ['v1/offers'], port: 8003 },
  { prefixes: ['v1/mcp'], port: 8010 },
];

const DEFAULT_PORT = 8004;

export function isLocalBaseUrl(baseUrl: string): boolean {
  return LOCAL_URL_PATTERN.test(baseUrl);
}

/**
 * Resolve the port for a given API path when running against a local backend.
 */
function resolvePort(path: string): number {
  for (const route of PORT_ROUTES) {
    if (route.prefixes.some((prefix) => path.startsWith(prefix))) {
      return route.port;
    }
  }
  return DEFAULT_PORT;
}

/**
 * Build a full URL for a local backend request, inserting the correct port.
 * The baseUrl is expected to NOT include a port (e.g. `http://192.168.1.5`).
 */
export function makeLocalUrl(baseUrl: string, path: string): string {
  // Strip any existing port from the base URL so we always use the mapped one
  const withoutPort = baseUrl.replace(/:\d+$/, '');
  return `${withoutPort}:${resolvePort(path)}/${path}`;
}
